
// import AttrItem from "./attr-item.vue";
import PointItem from "./point-item"
import CtaItem from "../hm-stage/ctaItem";

export default {
  name: 'HmTeaser',
  setting:[
    {
      key:'title',
      label: '标题',
      component: 'input',
      value: '标题'
    },
    {
      label: '背景图片',
      key: 'img',
      component: function (h, { key }) {
        return <SpImagePicker v-model={this.value[key]} size='small' />
      },
      value: ''
    },
    {
      label: '价格标签',
      key: 'goodData',
      component: function (h, { key }) {
        return  <PointItem v-model={this.value[key]} bgImg={this.value.img} padded={this.value.padded} />
      },
      value: [
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '',
          id: '',
          price: 0,
          market_price: 0,
          top: 0,
          left: 0,
          bg: '#FFF',
          hidden: false,
          leftType: 'left'
        }
      ]
    },
    {
      key:'content',
      label: '内容',
      component: 'input',
      value: 'Legal text describing something legal because that is needed in some markets.'
    },
    { label: '样式', key: 'padded', component: 'switch', value: false },
    {
      label: '按钮',
      key: 'cta',
      component: function (h, { key }){
        return <CtaItem  v-model={this.value[key]}></CtaItem>
      },
      value: {
        desc: '立即选购',
        urlData: {}
      }
    }
  ],
  transformIn: (v) => {
    const {
      name,
      base,
      config,
      data
    } = v
    return {
      name,
      ...base,
      ...config,
      data
    }
  },
  transformOut:(v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
        })
      },
      config: (v) => {
        return pickBy(v, {
          content: 'content',
          goodData: 'goodData',
          img: 'img',
          title: 'title',
          padded: 'padded',
          cta: 'cta'
        })
      }
    })
  }
}
